import { gql } from '@apollo/client'

export const GET_AWAITING_REALEFLOW_PROPERTIES = gql`
  query GetAwaitingRealeflowProperties {
    getAwaitingRealeflowProperties
  }
`

export const GET_UNPROCESSED_PROPERTY_LEADS = gql`
  query GetUnproccessedLeadsBatch($orgId: String!) {
    getUnproccessedLeadsBatch(orgId: $orgId) {
      success
      batches {
        _id
        lock
        createdAt
        leads
        productType
      }
    }
  }
`

export const GET_BATCH_AGENT_MATCHES = gql`
  query GetBatchAgentMatches($batchId: String!, $orgId: String!) {
    getBatchAgentMatches(batchId: $batchId, orgId: $orgId) {
      csvData
      filename
      agentMatchCount
      officeMatchCount
      noMatchCount
      agentInfoCount
    }
  }
`
